import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import AnimatedNumber from "animated-number-react";
import Marquee from "react-fast-marquee";

import BGPH2 from "../../assets/images/backgrounds/bnrimage.jpg";
import usd_img from "../../assets/images/case/usd.png";
import ugx_img from "../../assets/images/case/ugx.png";
import kes_img from "../../assets/images/case/kes.png";
import bif_img from "../../assets/images/case/bif.png";
import eur_img from "../../assets/images/case/eur.png";

import Navbar from "../Navbar/Main";
import Footer from "../Footer/Main";
import SearchLinks from "./Search";

/** CRA proxy targets package.json "proxy" (5001); calling this URL directly avoids proxy misconfig. */
function apiUrl(path) {
  if (path.startsWith("http")) return path;
  const envBase = process.env.REACT_APP_API_URL;
  if (envBase) {
    return `${String(envBase).replace(/\/$/, "")}${path}`;
  }
  if (process.env.NODE_ENV === "development") {
    return `http://localhost:5001${path}`;
  }
  return path;
}

// ---------------- Custom Hook for Fetch ---------------- //
const useFetch = (url, setter) => {
  useEffect(() => {
    const resolved = apiUrl(url);
    let cancelled = false;
    fetch(resolved)
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(`GET ${resolved} failed (${res.status}). ${text}`.trim());
        }
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        const normalized = Array.isArray(data) ? data : [];
        setter(normalized);
      })
      .catch((err) => {
        if (!cancelled) {
          console.error(err);
          setter([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [url]);
};


const Main = () => {

  useEffect(() => {
    // Create a script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;

    // Replace 'YOUR_INTUMWA_WIDGET_CODE' with your actual Intumwa chat widget code
    script.src = 'http://app.proto.cx/webchat/client.js';

    // Append the script to the document body
    document.body.appendChild(script);
    // Clean up the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  // ---------------- Data Statesss ---------------- //
  const [update, setUpdate] = useState(null);
  const [news, setNews] = useState([]);
  const [newskey, setNewskey] = useState([]);

  const [rates, setRates] = useState({ usd: [], ugx: [], kes: [], bif: [], eur: [] });

  // ---------------- Fetch Data ---------------- //
  useFetch("/updates", setUpdate);
  useFetch("/news", setNews);
  useFetch("/newskey", setNewskey);

  useFetch("/usd", (data) => setRates((prev) => ({ ...prev, usd: data })));
  useFetch("/ugx", (data) => setRates((prev) => ({ ...prev, ugx: data })));
  useFetch("/kes", (data) => setRates((prev) => ({ ...prev, kes: data })));
  useFetch("/bif", (data) => setRates((prev) => ({ ...prev, bif: data })));
  useFetch("/eur", (data) => setRates((prev) => ({ ...prev, eur: data })));

  return (
    <>
    <Navbar/>
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>
      <section className="page-header slider-one" >

              <div
                className="slider-one__image"
                style={{ backgroundImage: `url(${BGPH2})` }}
              ></div>

              <div className="container">
                <div className="search-popup__content">
                    <div className ="mandate1">
                        <p>
                        Rwanda's Central Bank mandated to ensure Price Stability and a Sound Financial System contributing to sustainable and inclusive growth
                        </p>
                    </div>
<form style={{ overflow: 'visible' }} action="/resultdata" onSubmit={e =>
                    e.preventDefault()}>
                <label htmlFor="search" className="sr-only">Search the National Bank of Rwanda</label>
                <SearchLinks />
                <button type="submit" aria-label="search submit" className="thm-btn">
                    <i className="icon-magnifying-glass"></i>
                </button>
            </form>
        </div>
              </div>
        </section> 
        <section className="fact-one">
        <div className="container">
          <div className="row">
          {  update && update.length > 0 ? update.map((up, index) => (
                  <Fragment key={up.id ?? `update-${index}`}>
                
            <div className="col-lg-3 col-md-6">
              <div className="fact-one__item">
                <div className="fact-one__count">
                  <span className="count-box">
                    <span
                      className="count-text"
                      data-stop={up.central_bank_rate}
                      data-speed="500"
                    >
                      <AnimatedNumber
                        value={Number(up.central_bank_rate)}
                        duration={50}
                      />
                    </span>
                  </span>
                  %
                </div>
                <h3 className="fact-one__title">Central Bank Rate </h3>
                <p className="career-one__title1">{up.central_bank_month}</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="fact-one__item">
                <div className="fact-one__count">
                  <span className="count-box">
                    <span
                      className="count-text"
                      data-stop={up.inflation_rate}
                      data-speed="500"
                    >
                      {" "}
                      <AnimatedNumber
                        value={Number(up.inflation_rate)}
                        duration={30}
                        // formatValue={(v) => Math.round(v)}
                      />
                    </span>
                  </span>
                  %
                </div>
                <h3 className="fact-one__title">Inflation rate </h3>
                <p className="career-one__title1">{up.inflation_month}</p>
              </div>
            </div>
                   </Fragment>
                     )) : update && update.length === 0 ? (
                <p className="col-12 text-muted small">Rates are loading or temporarily unavailable.</p>
              ) : (
                <p className="col-12">Loading…</p>
              )
                }
                      <div className="col-lg-6 col-md-6">
              <div className="fact-one__item1">
                                      {
                                  newskey ? newskey.map((n, index) => (
                                        <div className="testimonial-card-two">
                                            <div className="testimonial-card-two__text">
                                              <p className="career-one__title1"><Link to={`${n.details}`} target="_blank">{n.title}</Link></p>
                                                  {n.summary}
                                                  </div>
                                            </div>
                                            )) : <p>Loading.....</p>
                                          }
                                        
              </div>
            </div>
            
          </div>
        </div>
      </section>
      <section className="service-five pt-10 pb-30">
            <div className="container">
            <div className="block-title__tagline_ccy">
        <table>
          <tr>
            <td><Link to="/exchangeRate">
         <Marquee>
                        {Object.entries(rates).map(([ccy, data]) =>
                          data.map((rate, i) => (
                            <span key={`${ccy}-${i}`}>
                              <img
                                src={{ usd: usd_img, ugx: ugx_img, kes: kes_img, bif: bif_img, eur: eur_img }[ccy]}
                                height="15"
                                alt={ccy}
                              />
                              {ccy.toUpperCase()}: Buying: {rate.buying_rate}, Selling: {rate.selling_rate} |
                            </span>
                          ))
                        )}
                      </Marquee>
            </Link>
            </td>
            <td>
            <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
              <Link to="/exchangeRate" className="documentation-knowledge-btn">More</Link>
             </div>
             </td> 
          </tr>
          </table>
        </div>  
        </div>
        <p></p>
        <p></p>
        <div className="container">
                <div className="row row-gutter-y-30">
                <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/FinancialStability">Financial Stability</Link></h3>
                          </div>
                          <div className="documentation-content">
                          <ul> 
                          <li><Link to="/banksupervision"><i className="fa fa-angle-right"></i> Bank Supervision</Link></li> 
                          <li><Link to="/microfinance"><i className="fa fa-angle-right"></i> Microfinance Supervision</Link></li> 
                          <li><Link to="/paymentsystem"><i className="fa fa-angle-right"></i> Payment Systems</Link></li> 
                          <li><Link to="/insurances"><i className="fa fa-angle-right"></i> Insurance Supervision</Link></li> 
                          <li><Link to="/pensions"><i className="fa fa-angle-right"></i> Pension Supervision {Array(22).fill('\u00A0').join('')}</Link></li> 

                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to='/FinancialStability'>View More </Link> 
                          </div>
                      </div>
                    </div>     
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/FinancialMarket">Financial Markets</Link></h3>
                          </div>
                          <div className="documentation-content">
                          <ul>
                          <li><Link to="/interbankmarket"><i className="fa fa-angle-right"></i> Interbank Market</Link></li> 
                          <li><Link to="/avgexchangerate"><i className="fa fa-angle-right"></i> Monthly and Annual Exchange Rates</Link></li> 
                          <li><Link to="/mminterestrates"><i className="fa fa-angle-right"></i> Foreign Exchange Reserves</Link></li> 
                          <li><Link to="/yieldcurve"><i className="fa fa-angle-right"></i> Interest Rates and Yield Curve</Link></li> 
                          <li><Link to="/mminstruments"><i className="fa fa-angle-right"></i> Financial Instruments</Link></li> 

                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to="/FinancialMarket">View More </Link> 
                          </div>
                      </div>
                    </div>       
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/lawsandregulations">Laws and Regulations</Link></h3>
                          </div>
                          <div className="documentation-content">
                          <ul>
                         <li><Link to="/crosscuttings"><i className="fa fa-angle-right"></i> Law Governing the BNR</Link></li> 
                          <li><Link to="/regdigest"><i className="fa fa-angle-right"></i> Regulatory Digest and Market Consultation</Link></li> 
                          <li><Link to="/banking"><i className="fa fa-angle-right"></i> Banking</Link></li> 
                          <li><Link to="/insurance"><i className="fa fa-angle-right"></i> Insurance</Link></li> 
                          <li><Link to="/pension"><i className="fa fa-angle-right"></i> Pension</Link></li> 
                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to="/lawsandregulations">View More </Link> 
                          </div>
                      </div>
                    </div>
                 
                </div>
                <div className="row row-gutter-y-30">
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/education">Financial Inclusion</Link></h3>
                          </div>
                          <div className="documentation-content">
                            <ul>
                              <li><Link to="/inclusiondata"><i className="fa fa-angle-right"></i> Financial Inclusion Data</Link></li>
                              <li><Link to="/educate"><i className="fa fa-angle-right"></i> Financial Education</Link></li>
                              <li><Link to="/regulatorysandbox"><i className="fa fa-angle-right"></i> Regulatory Sandbox</Link></li>
                              <li><Link to="/inclusionpolicy"><i className="fa fa-angle-right"></i> Policies, Strategies and Roadmaps</Link></li>
                              <li><Link to="/financialinnovation"><i className="fa fa-angle-right"></i> CBDC</Link></li>
                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to="/education">View More </Link> 
                          </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/MarketConduct">Market Conduct</Link></h3>
                          </div>
                          <div className="documentation-content">
                            <ul>
                              <li><Link to="/Sectorcharters"><i className="fa fa-angle-right"></i> Sector Charters</Link></li>
                              <li><Link to="/Surveyreports"><i className="fa fa-angle-right"></i> Survey reports</Link></li>
                              <li><Link to="/Nondeposittaking"><i className="fa fa-angle-right"></i> Non deposit Taking</Link></li>
                              <li><Link to="/Trustcompanies"><i className="fa fa-angle-right"></i> Trust and Company Service Providers</Link></li>
                              <li><Link to="/Forexbureaus"><i className="fa fa-angle-right"></i> Forex Bureaus {Array(30).fill('\u00A0').join('')}</Link></li>
                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to="/MarketConduct">View More </Link> 
                          </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                      <div className="documentation-box documentation-knowledge-design-2">
                          <div className="documentation-card-header">
                                   <h3><Link to="/SustainableFinance">Sustainable Finance</Link></h3>
                          </div>
                          <div className="documentation-content">
                          <ul>
                              <li><Link to="/governance"><i className="fa fa-angle-right"></i> Sustainable Finance Governance</Link></li>
                              <li><Link to="/regulatoryframework"><i className="fa fa-angle-right"></i> Regulatory Frameworks</Link></li>
                              <li><Link to="/reportandpublication"><i className="fa fa-angle-right"></i> Reports and Publications</Link></li>
                              <li><Link to="/capacity"><i className="fa fa-angle-right"></i> Capacity Buildings and Awareness</Link></li>
                              <li><Link to="/otherreport"><i className="fa fa-angle-right"></i> Useful Links</Link></li>
                            </ul>
                          </div>
                          <div className="btn-wrap documentation-knowledge-design-2-btn-wrap">
                            <Link className="documentation-knowledge-btn" to="/SustainableFinance">View More </Link> 
                          </div>
                      </div>
                    </div>   
                    </div>
                <p></p>
            </div>
            <div className="container">
                                          

        <div className="home-updates-header">
          {/* <p className="home-updates-eyebrow">Latest from BNR</p> */}
          <p className="home-updates-eyebrow">
            Stay informed with recent reports, updates, and key announcements.
          </p>
        </div>
                <div className="row row-gutter-y-30 home-updates-grid">
         {
                    news ? news.map((n, index) => (
                    <div className="col-lg-4 col-md-12" key={n.id ?? `news-${index}`}>
                        <div className="blog-card-two">
                            <div className="blog-card-two__image" style={{ backgroundImage: `url(${`../${n.image}`})`}}>
                            </div>
                            <div className="blog-card-two__content">
                                <h3 className="blog-card-two__title"><Link to={`${n.details}`} target="_blank" rel="noreferrer">{n.title} </Link></h3>
                                <Link className="blog-card-two__cta" to={`${n.details}`} target="_blank" rel="noreferrer">
                                  Read more <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                
                )) : <p>Loading.....</p>
                                    }
                </div>
            </div>
        </section>
            
   <Footer/>  
    </>
  );
};

export default Main;
